<template>
  <div class="messaging-rooms">
    <div class="section-header">
      <div class="section-headers">
        Messages
      </div>
      <new-room @newRoom="newRoom"></new-room>
    </div>
    <div class="card card--white">
      <div class="rooms" v-if="rooms.length !== 0">
        <div class="room-list">
          <room-preview
            :room="room"
            :active="roomSelected == room"
            v-for="room in rooms"
            :key="room.id"
            class="room"
            @selected="selectRoom(room)"
            />
        </div>
        <messaging-room v-if="!isMobile && roomSelected.id" :room="roomSelected" :recipient="recipient" :key="roomSelected.id" />
        <chat-window v-if="isMobile && roomSelected.id" @dismiss="roomSelected={}" :recipient="recipient" :room="roomSelected"></chat-window>
      </div>
      <div class="card card--container" v-if="!loading && rooms.length === 0">
        You don't have any converstations.
        <new-room @newRoom="newRoom"></new-room>
      </div>
    </div>
  </div>
</template>

<script>
import dataStore from "@/services/api/store";
import messagingRoom from "@/components/messages/messageRoom";
import chatWindow from "@/components/messages/chatWindow";
import roomPreview from "./roomPreview";
import User from "@/services/api/authUser";
import newRoom from "./newRooms";
const MESSAGES_ROOM_STORE = "CoachMessagingRooms";

export default {
  data() {
    return {
      rooms: [],
      roomSelected: {},
      loading: true,
      isMobile: false
    };
  },
  components: {
    messagingRoom,
    roomPreview,
    newRoom,
    chatWindow
  },
  created() {
    this.$eventHub.$emit("tutorial", "messaging");
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });

    dataStore
      .findAll(MESSAGES_ROOM_STORE, { active: true }, { force: true })
      .then(rooms => {
        this.rooms = rooms;
        // Dont auto select if they're on mobile
        if (!this.isMobile && rooms.length > 0) {
          this.roomSelected = rooms[0];
        }
      })
      .then(() => (this.loading = false));
  },
  methods: {
    selectRoom(room) {
      this.roomSelected = room;
    },
    newRoom(room) {
      if (!this.rooms.find(r => r.id === room.id)) {
        this.rooms = [room, ...this.rooms];
      }
      this.roomSelected = room;
    },
    onResize() {
      let newSize = window.innerWidth;
      let mobileWidth = 740;
      if (!this.roomSelected.id && this.isMobile && newSize >= mobileWidth) {
        this.roomSelected = this.rooms[0];
      }
      this.isMobile = newSize < mobileWidth;
    }
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  computed: {
    recipient() {
      if (!this.roomSelected.id) {
        return {};
      }
      return this.roomSelected.users.find(user => user.id != User.id);
    }
  }
};
</script>

<style lang="less">
.messaging-rooms {
  .rooms {
    display: flex;
    flex-direction: row;
    padding: 0;
    flex: 1 1 100%;
    width: 100%;
    @media (min-width: 740px) {
      height: 75vh;
    }
  }

  .messages-tab {
    position: relative;
    width: 100%;
  }

  .messages-list {
    padding: 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .message-name {
    font-weight: bold;
  }

  .message {
    margin-top: 8px;
  }

  .message-input-container {
    border: 1px solid rgba(0, 0, 0, 0.12);
    position: relative;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .message-input {
    width: 100%;
    border-style: none;
    margin: 0;
    padding: 20px;
  }

  .message-input:focus {
    outline: none;
  }

  .room-photo {
    width: 50px;
    height: 50px;
    background-color: #bebebe;
    margin-right: 20px;
  }

  .room-name {
    font-size: 18px;
    font-weight: normal;
    text-align: left;
    line-height: 1;
    color: #000000;
  }

  .room-content {
    font-size: 16px;
    margin-top: 6px;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    -ms-text-overflow: ellipsis;
    text-overflow: ellipsis;
    text-align: left;
    color: #8b8b8b;
  }

  .room-list {
    flex: 45%;
    flex-grow: 0;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    overflow: scroll;
    max-height: 100%;

    @media (max-width: 740px) {
      width: 100%;
      flex: 1;
    }
    /*li:last-child {*/
    /*border-bottom: 1px solid rgba(0, 0, 0, 0.12);*/
    /*}*/
  }

  .room {
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
    padding-right: 14px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    cursor: pointer;
  }
}
</style>
